import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  Companion_instance13way2il9a8jt as Companion_instance,
  Enum3alwj03lh1n41 as Enum,
} from '../../../../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { listOf1jh22dvmctj1r as listOf } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { EnumType11cgb4df0n5r9 as EnumType } from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/CompiledGraphQL.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var static_init_called;
function static_init() {
  if (static_init_called)
    return Unit_instance;
  static_init_called = true;
  Badge_Default_instance = new (Badge())('Default', 0, 'Default');
  Badge_Alternate_instance = new (Badge())('Alternate', 1, 'Alternate');
  Badge_UNKNOWN___instance = new (Badge())('UNKNOWN__', 2, 'UNKNOWN__');
  if (Companion_instance_0 === VOID) {
    Companion_instance;
    new (Companion())();
  }
}
var Badge_Default_instance;
var Badge_Alternate_instance;
var Badge_UNKNOWN___instance;
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance_0 = this;
        this.i6r_1 = new (EnumType())('Badge', listOf(['Default', 'Alternate']));
      }
      x6r(rawValue) {
        switch (rawValue) {
          case 'Default':
            return Badge_Default_getInstance();
          case 'Alternate':
            return Badge_Alternate_getInstance();
          default:
            return Badge_UNKNOWN___getInstance();
        }
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance_0;
function Companion_getInstance() {
  static_init();
  return Companion_instance_0;
}
var BadgeClass;
function Badge() {
  if (BadgeClass === VOID) {
    class $ extends Enum() {
      constructor(name, ordinal, rawValue) {
        super(name, ordinal);
        this.d6s_1 = rawValue;
      }
    }
    initMetadataForClass($, 'Badge');
    BadgeClass = $;
  }
  return BadgeClass;
}
function Badge_Default_getInstance() {
  static_init();
  return Badge_Default_instance;
}
function Badge_Alternate_getInstance() {
  static_init();
  return Badge_Alternate_instance;
}
function Badge_UNKNOWN___getInstance() {
  static_init();
  return Badge_UNKNOWN___instance;
}
//region block: exports
export {
  Badge as Badge28jlxgdx0n9um,
  Badge_Alternate_getInstance as Badge_Alternate_getInstance21qda9n74w8bc,
  Badge_Default_getInstance as Badge_Default_getInstancenqkdjea8uvc7,
  Companion_getInstance as Companion_getInstance1k2utlogu14e7,
};
//endregion

//# sourceMappingURL=Badge.mjs.map
